import CharactersList from './CharactersList';

export default CharactersList;
